import { LayoutItem } from "../interfaces";

/**
 * Layout: Italian
 */
export default <LayoutItem>{
  layout: {
    default: [
      "\\ 1 2 3 4 5 6 7 8 9 0 ' \u00EC {bksp}",
      "q w e r t y u i o p \u00E8 +",
      "a s d f g h j k l \u00F2 \u00E0 \u00F9",
      "{shift} < z x c v b n m , . - {shift}",
      ".com @ {space} {enter}",
    ],
    shift: [
      '| ! " \u00A3 $ % & / ( ) = ? ^ {bksp}',
      "Q W E R T Y U I O P \u00E9 *",
      "A S D F G H J K L \u00E7 \u00B0 \u00A7",
      "{shift} > Z X C V B N M ; : _ {shift}",
      ".com @ {space} {enter}",
    ],
  },
};
